import React, { useContext } from 'react';
import { GenericTable, SHAPE, SeatingViewerContext } from '@wix/seating-common-components';
import { WholeTableReservationWrapper } from '../whole-table-reservation-wrapper';
export const Table = ({ definition }) => {
    const { shapeTypeConfig } = useContext(SeatingViewerContext);
    const { hideSeats = false, forcedCursor = {}, perShapeConfig } = shapeTypeConfig[SHAPE.TABLE] ?? {};
    const { fillColor, strokeColor, color } = (perShapeConfig ?? {})[definition.id] ?? {};
    return (React.createElement(WholeTableReservationWrapper, { definition: definition },
        React.createElement(GenericTable, { definition: definition, hideSeats: hideSeats, fillColor: fillColor, strokeColor: strokeColor, color: color, forcedCursor: forcedCursor })));
};
//# sourceMappingURL=table.js.map